import formatMoney from '../../core/formatMoney';
import getTileHTML from './get-tile-html';
import checkProductsExist from './check-products-exist';
import removeFromCart from './remove-from-cart';
import fetchUserLists from './fetch-user-lists';

// Save the list products on load to be able to send the object on remove
let saveforlater_products = [];

// Move a cart item to the saved for later list
const moveToSavedForLater = async (lineItem, lineNum, elem) => {
  return new Promise(async (resolve, reject) => {
    const itemData = window._swat.platform.transformCartItem(lineItem);
    itemData.du = `${window.location.origin}${itemData.du.substr(itemData.du.indexOf('/products/'))}`;

    if (window.theme.savedForLater.listId === 0) {
      const lists = await fetchUserLists();
      console.log('lists', lists);

      const saved_for_later_list = lists.find(list => list.lname === 'My SFL List');
      if (typeof saved_for_later_list === 'undefined') {
        console.log(`Customer's saved for later list not found`);
        reject(`Customer's saved for later list not found`);
        return;
      }

      window.theme.savedForLater.listId = saved_for_later_list.lid;
    }

    // Success callback.
    const onSuccess = function (response) {
      console.log("Successfully Added the products to Save for Later List", response);
      removeFromCart(lineNum);
    };

    // Error Callback. 
    const onError = function (error) {
      console.log("There was an Error, while Adding products to the Save For Later List", error);
      reject(error);
      return;
    };

    window._swat.SaveForLater.add(
      window.theme.savedForLater.listId,
      [
        {
          du: itemData.du,
          empi: itemData.empi,
          epi: itemData.epi,
        }
      ],
      onSuccess,
      onError
    );
  });
};

// Button to move a cart item to the saved for later list
const initMoveToSavedForLater = () => {
  document.addEventListener('click', async (e) => {
    const target = e.target.closest('[data-cart-save-for-later]');
    if (!target) return;

    e.preventDefault();

    const cartItem = target.closest('[data-cart-item]');
    const lineNum = cartItem ? Number(cartItem.getAttribute('data-line')) : null;
    let lineItem = window.ShopifyCartData.items[lineNum - 1];

    // Move to save for later list and remove
    if (typeof lineItem !== 'undefined') {
      await moveToSavedForLater(lineItem, lineNum, target);
      return;
    }

    fetch('/cart.js')
      .then(res => res.json())
      .then(async (cart) => {
        window.ShopifyCartData = cart;
        lineItem = window.ShopifyCartData.items[lineNum - 1];
        await moveToSavedForLater(lineItem, lineNum, target);
      });
  });
};

const initRemoveFromSavedForLater = () => {
  document.addEventListener('click', (e) => {
    const removeBtn = e.target.closest('[data-cart-saveforlater-items] [data-remove-wishlist-item]');
    if (!removeBtn || !window._swat) return;

    const wishlistItem = removeBtn.closest('[data-cart-wishlist-item]');
    const remove_id = wishlistItem ? wishlistItem.getAttribute('data-cart-wishlist-item-id') : null;
    const remove_object = saveforlater_products.find(item => item.id == remove_id);
    console.log('Remove from list', remove_id, remove_object);

    if (typeof remove_object === 'undefined') {
      return;
    }

    window._swat.deleteFromList(window.theme.savedForLater.listId, {
      du: remove_object.du,
      empi: remove_object.empi,
      epi: remove_object.epi,
    }, (response) => {
      window.location.reload(false);
    }, (error) => {
      console.log('There was an Error, while Removing products to the Save For Later List', error);
    });
  });
};

export default () => {
  const section = document.querySelector('[data-cart-saveforlater]');
  const itemsContainer = document.getElementById('saveforlater-items');

  if (!section || !itemsContainer) {
    return;
  }

  // Saved for later list has been initialized correctly, we can now load the items, build and show them
  const onSuccess = function (response) {
    console.log('Successfully Initialized, and we created a Save for Later List', response);

    window.theme.savedForLater.listId = response.listid;
    // document.querySelectorAll('[data-cart-save-for-later]').forEach(el => el.classList.remove('visually-hidden'));
    // document.querySelectorAll('.cart-item__move-to-wishlist').forEach(el => el.style.paddingLeft = '16px');
    const loadingEl = document.querySelector('[data-cart-saveforlater-loading]');
    if (loadingEl) {
      loadingEl.remove();
    }

    // https://developers.swym.it/docs/fetch-list-details
    window._swat.fetchListDetails({
      'lid': window.theme.savedForLater.listId,
    }, (listDetails) => {
      console.log('Successfully fetched List details', listDetails);

      initMoveToSavedForLater();
      initRemoveFromSavedForLater();

      const emptyEl = document.querySelector('[data-cart-saveforlater-empty]');
      if (!listDetails || !Array.isArray(listDetails.items) || listDetails.items.length === 0 || typeof window.theme.customer.id === 'undefined') {
        if (emptyEl) emptyEl.classList.add('visible');

        // We decided not to show the section if there are no items
        section.classList.add('cart-saveforlater--empty');
        return;
      }

      saveforlater_products = listDetails.items;

      if (emptyEl) {
        emptyEl.remove();
      }

      let count_list_item = 0;
      saveforlater_products.forEach((list_product) => {
        try {
          const option_html = getTileHTML(list_product, itemsContainer);
          const optionsEl = document.querySelector(`[data-cart-saveforlater-items] [data-cart-wishlist-item-id="${list_product.id}"] [data-cart-wishlist-item-options]`);
          if (optionsEl) optionsEl.innerHTML = option_html;

          const priceEl = document.querySelector(`[data-cart-saveforlater-items] [data-cart-wishlist-item-id="${list_product.id}"] [data-cart-wishlist-item-price]`);
          if (priceEl) {
            if (window.Shopify.country === 'US') {
              priceEl.innerHTML = formatMoney(Number(list_product.pr) * 100, theme.moneyFormat);
            } else {
              priceEl.innerHTML = formatMoney(Math.ceil(Number(list_product.pr) * window.Shopify.currency.rate) * 100, theme.moneyFormat);
            }
          }

          // Cleanup title
          let product_title = list_product.dt;
          if (product_title.indexOf(' - ') !== -1) {
            const product_title_parts = product_title.split(' - ');
            const last_title_part = product_title_parts[product_title_parts.length - 1];
            product_title = product_title.replace(` - ${last_title_part}`, '');
            const titleEl = document.querySelector(`[data-cart-saveforlater-items] [data-cart-wishlist-item-id="${list_product.id}"] [data-cart-wishlist-item-title]`);
            if (titleEl) titleEl.innerHTML = product_title;
          }

          count_list_item++;

          // User might have a product that doesn't exist in store in its list, remove it if it's the case
          if (count_list_item === saveforlater_products.length) {
            checkProductsExist(saveforlater_products, 'saveforlater');
          }

          window.dispatchEvent(new Event('resize'));
        } catch (error) {
          console.log('Save for later list error', error);
        }
      });

      // Display the total number of items in the save for later list on the user's wishlist page
      const saveforlaterCountEl = document.querySelector('[data-saveforlater-count]');
      if (saveforlaterCountEl) {
        saveforlaterCountEl.textContent = "(" + count_list_item + ")";
      };
    }, (error) => {
      console.log("Error while fetching List details", error);
      return;
    });
  };

  // Call the Init function.
  if (typeof window._swat.SaveForLater !== 'undefined') {
    window._swat.SaveForLater.init(onSuccess, (error) => {
      console.log('There was an Error, while creating the Save For Later List', error);
    });
  }
};
